import { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";

import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Copyright } from "./components/copyright";
import Chooseus from "./components/chooseus";
import Works from "./components/works";
import { Footer } from "./components/footer";
import { Services } from "./components/services";

const Home = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);


  return (
    <div>
      <Header />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Chooseus />
      <Works />
      <Services data={landingPageData.Contact} />
    </div>
  );

}


export default Home;
